import React from 'react';
import Callout from 'src/components/InformationCallout/Callout';
import FontAwesomeIcon from 'src/components/Icon';
import {
  IUseCalcomConnection,
  useCalcomOauthConnection,
} from '../../CustomHooks/useCalcomOauthConnection';
import './service-request-scheduling-note.scss';

interface ServiceRequestSchedulingNoteProps {
  compact?: boolean;
}

const ServiceRequestSchedulingNote = ({
  compact = false,
}: ServiceRequestSchedulingNoteProps) => {
  const { isConnected, isLoadingStatus }: IUseCalcomConnection =
    useCalcomOauthConnection();

  if (isLoadingStatus || !isConnected) {
    return null;
  }

  if (compact) {
    return (
      <div className="sr-scheduling-note-compact">
        <Callout
          variant="info"
          size="small"
          icon={
            <FontAwesomeIcon glyph="info-circle" weight="solid" size="small" />
          }
          title="Scheduled in Juniper, not Cal.com"
          subtitle="Cal.com booking covers key pickups and walkthroughs."
        />
      </div>
    );
  }

  return (
    <Callout
      variant="info"
      title="Scheduled with Juniper, not Cal.com"
      subtitle={
        <>
          Cal.com booking currently powers key pickups and walkthroughs.
          Appointments for service requests are made with Juniper&apos;s
          built-in scheduling engine — they&apos;re not booked through Cal.com
          or drawn from your Cal.com availability.
        </>
      }
    />
  );
};

export default ServiceRequestSchedulingNote;
